import { Grid } from "@mui/material";
import HourPicker from "components/HourPicker";

type EventStartTimePickerProps = {
  value?: Date | null;
  onChange: (value: Date | null) => void;
};

export default function EventStartTimePicker(props: EventStartTimePickerProps) {
  return (
    <Grid item xs={12} sm={12} md={4}>
      <HourPicker {...props} labelKey="startTime" />
    </Grid>
  );
}
